<app-configuracao-caixa #configuracaoComponent title="Contas do Caixa Arquivadas" [acoesConta]="acoesConta"
  [contas]="contas" [mostrarAdicionarTipo]="false" (reloadPage)="reloadPage()">

  <a routerLink="/configuracao-caixa" mat-raised-button class="button-menu" matTooltip="Contas Ativas">
    <i class="button-menu-icon pi pi-eye"></i>
    <span class="button-menu-label">Contas Ativas</span>
  </a>

</app-configuracao-caixa>